import { LIST_VIEW_LOCALSTORAGE_ITEM_NAME } from '../constants';
import { getLocalStorageItem } from './getLocalStorageItem';
import { getListViewBoard } from '../selectors/getListViewBoard';
import { TBoardId } from '../../../../types/types';
import { getAppState } from '../../../../store/configureStore';
import { IListViewBoard } from '../store/listViewBoard/types';

export const setLocalStorageItem = (
    boardId: TBoardId
) => {
    if (!localStorage) return;

    const state = getAppState();
    const storeItem = getListViewBoard(state, boardId);
    if (!storeItem) return;

    const localStorageItem = getLocalStorageItem();
    const newBoardValue: IListViewBoard = {
        ...storeItem,
        isBlocked: false, // isBlocked, printMode, isAddCardShow временные данные, поэтому их не храним в localStorage
        printMode: false,
    }
    localStorage.setItem(
        LIST_VIEW_LOCALSTORAGE_ITEM_NAME,
        JSON.stringify({
            ...localStorageItem,
            [boardId]: newBoardValue
        })
    );
};
